import messages from '../../locale/messages';
import { inputDescLimit } from '../../helpers/FieldRestriction';

const validate = values => {
    const errors = {}

    if (values?.otherReason?.length > inputDescLimit) {
        errors.otherReason = messages.cancelReasonExceed;
    } else if (!values.otherReason || values?.otherReason.trim() == '') {
        errors.otherReason = messages.required;
    }

    return errors
}

export default validate